import type { CampaignLevel, Difficulty } from '../types';

type Chapter = {
  name: string;
  difficulty: Difficulty;
  categories: string[];
  words: number[];
  accuracy: number[];
  missed: number;
  time: number | null;
};

const chapters: Chapter[] = [
  { name: 'Cadet · Khởi động', difficulty: 'beginner', categories: ['animals', 'food', 'colors', 'numbers', 'starter'], words: [6, 8, 10, 12, 14], accuracy: [65, 68, 70, 72, 75], missed: 3, time: null },
  { name: 'Gunner · Phản xạ', difficulty: 'easy', categories: ['home', 'school', 'actions', 'feelings', 'explorer'], words: [10, 12, 14, 16, 18], accuracy: [72, 74, 76, 78, 80], missed: 3, time: null },
  { name: 'Sharpshooter · Nhịp độ', difficulty: 'normal', categories: ['transport', 'nature', 'daily', 'adjectives', 'navigator'], words: [14, 16, 18, 20, 22], accuracy: [76, 78, 80, 82, 84], missed: 2, time: 120 },
  { name: 'Sergeant · Tư duy', difficulty: 'hard', categories: ['academic', 'technology', 'challenger'], words: [16, 18, 20, 22, 24], accuracy: [80, 82, 84, 85, 86], missed: 2, time: 110 },
  { name: 'Commander · Chiến thuật', difficulty: 'hard', categories: ['business', 'environment', 'challenger'], words: [18, 20, 22, 24, 26], accuracy: [83, 84, 85, 86, 87], missed: 1, time: 105 },
  { name: 'Elite · Mastery', difficulty: 'expert', categories: ['academic', 'technology', 'business', 'environment', 'mastery'], words: [20, 22, 24, 26, 28], accuracy: [85, 86, 87, 88, 90], missed: 1, time: 100 },
];

export const campaignLevels: CampaignLevel[] = chapters.flatMap((chapter, chapterIndex) => chapter.words.map((wordsRequired, stageIndex) => ({
  id: `campaign-${chapterIndex + 1}-${stageIndex + 1}`,
  chapter: chapterIndex + 1,
  chapterName: chapter.name,
  stage: stageIndex + 1,
  difficulty: chapter.difficulty,
  categories: chapter.categories,
  wordsRequired,
  accuracyRequired: chapter.accuracy[stageIndex],
  maxMissed: chapter.missed,
  timeLimitSeconds: chapter.time,
})));

export function isLevelUnlocked(level: CampaignLevel, completed: Record<string, number>): boolean {
  const index = campaignLevels.findIndex((entry) => entry.id === level.id);
  return index === 0 || completed[campaignLevels[index - 1].id] > 0;
}
